<template>
  <div
    id="ControlExistente"
    v-if="
      $store.state.global_privilegio_admin_registro_control_medida.ver">
    <AdminMenu />
    <div class="row justify-content-md-center align-items-center">
      <div class="col-md-10">
        <div class="row container_admin">
          <!-- LISTA DE CONTROL EXISTENTE -->
          <div class="col-6 text-left mt-2">
            <b class="titulo">Control Existente y/o</b>
            <br />
            <b class="titulo">Medida de Intervención</b>
          </div>
          <div class="col-6 d-flex justify-content-end mt-2">
            <button
              v-show="
                $store.state.global_privilegio_admin_registro_control_medida
                  .crear
              "
              type="button"
              class="btn boton_guardar1"
              data-toggle="modal"
              data-target="#agregarcontrol"
            >
              <img
                src="img/iconos/control.png"
                alt="logo-color"
                class="icono mr-2"
              />Nuevo Control y/o Medida de Intervención
            </button>
          </div>
          <div class="col-12 table mt-3" v-if="array_control.length > 0">
            <v-client-table
              class="col-md-12 mt-3"
              :columns="columns"
              :data="array_control"
              :options="options"
            >
              <div slot="opciones" slot-scope="props">
                  <button
                    class="btn dropdown-toggle boton_12"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <ul class="dropdown-menu b-dropdown-opt" role="menu">
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="
                              consultar_control_medidas(
                                props.row.id,
                                props.row.id_peligro,
                                props.row.id_subcla
                              )
                            "
                            v-show="
                              $store.state
                                .global_privilegio_admin_registro_control_medida
                                .editar
                            "
                            >&nbsp;<b>Editar</b></a
                          >
                        </li>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="eliminar_control(props.row.id)"
                            v-show="
                              $store.state
                                .global_privilegio_admin_registro_control_medida
                                .eliminar
                            "
                            >&nbsp;<b>Eliminar</b></a
                          >
                        </li>
                    </ul>
                  </button>
              </div>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR CONTROL Y MEDIDA DE INTERVENCIÓN -->
    <div
      class="modal fade"
      id="agregarcontrol"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"
                ><b
                  >Nuevo Control Existente y/o Medida de Intervención</b
                ></label
              >
              <br />
            </div>
            <div class="box-body row">
              <div class="table">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td rowspan="2">
                        <label class="color_letra"
                          >Describa el Control o Medida de Intervención:</label
                        >
                        <textarea
                          v-model="control_medida"
                          class="form-control boton_texto"
                          rows="3"
                        ></textarea
                        ><br />
                      </td>
                      <td>
                        <label class="color_letra">Asignación a Peligro:</label>
                        <select
                          class="form-control boton_texto"
                          v-model="id_agregar_peligro"
                          @change="consulta_subcla_control()"
                        >
                          <option value="">Peligros</option>
                          <option
                            v-for="(
                              item_control, index
                            ) of mostrar_peligros_control"
                            :value="item_control.key_peligro_control"
                            :key="index"
                          >
                            {{ item_control.control_nuevo_peligros }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <label class="color_letra"
                          >Asignación a Controles Existentes:</label
                        ><br />
                        <select
                          class="form-control boton_texto"
                          v-model="control_existente"
                        >
                          <option value="" selected disabled>
                            Seleccionar...
                          </option>
                          <option value="Fuente">Fuente</option>
                          <option value="Medios">Medio</option>
                          <option value="Individuo">Individuo</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label class="color_letra"
                          >Asignación a la Subclasificación:</label
                        >
                        <select
                          class="form-control boton_texto"
                          v-model="id_agregar_subcla"
                        >
                          <option value="">Subclasificación</option>
                          <option
                            v-for="(
                              item_control1, index
                            ) of mostrar_subcla_control"
                            :value="item_control1.key_sublca"
                            :key="index"
                          >
                            {{ item_control1.control_nuevo_sub }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <label class="color_letra"
                          >Asignación a las Medidas de Intervención:</label
                        ><br />
                        <select
                          class="form-control boton_texto"
                          v-model="medida_intervencion"
                        >
                          <option value="" selected disabled>
                            Seleccionar...
                          </option>
                          <option value="Eliminación">Eliminación</option>
                          <option value="Sustitución">Sustitución</option>
                          <option value="Controles de Ingeniería">
                            Controles de Ingeniería
                          </option>
                          <option
                            value="Controles Administrativos, Señalización, Advertencia"
                          >
                            Controles Administrativos, Señalización, Advertencia
                          </option>
                          <option
                            value="Equipos/Elementos de Protección Personal"
                          >
                            Equipos/Elementos de Protección Personal
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-12">
                <center>
                  <button
                    type="button"
                    class="btn boton_guardar1"
                    style="width: 220px !important"
                    @click="agregar_control_medida()"
                  >
                    Guardar
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EDITAR CONTROL Y MEDIDA DE INTERVENCIÓN -->
    <div
      class="modal fade"
      id="editarcontrol"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"
                ><b
                  >Editar Control Existente y/o Medida de Intervención</b
                ></label
              >
              <br />
            </div>
            <div class="box-body row">
              <div class="table">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td rowspan="2">
                        <label class="color_letra"
                          >Describa Control Existente y/o Medida de
                          Intervención:</label
                        >
                        <textarea
                          v-model="c_control_media"
                          class="form-control boton_texto"
                          rows="3"
                        ></textarea
                        ><br />
                      </td>
                      <td>
                        <label class="color_letra">Asignación a Peligro:</label>
                        <select
                          class="form-control boton_texto"
                          v-model="c_peligro"
                          @change="consulta_subcla_control2"
                        >
                          <option value="">Peligros</option>
                          <option
                            v-for="(
                              item_control2, index
                            ) of mostrar_peligros_control"
                            :value="item_control2.control_nuevo_peligros"
                            :key="index"
                          >
                            {{ item_control2.control_nuevo_peligros }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <label class="color_letra"
                          >Asignación a Controles Existentes:</label
                        ><br />
                        <select
                          class="form-control boton_texto"
                          v-model="c_control_existente"
                        >
                          <option value="" selected disabled>
                            Seleccionar...
                          </option>
                          <option value="Fuente">Fuente</option>
                          <option value="Medios">Medio</option>
                          <option value="Individuo">Individuo</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label class="color_letra"
                          >Asignación a la Subclasificación:</label
                        >
                        <select
                          class="form-control boton_texto"
                          v-model="c_subcla"
                        >
                          <option value="">Subclasificación</option>
                          <option
                            v-for="(
                              item_control3, index
                            ) of mostrar_subcla_control"
                            :value="item_control3.control_nuevo_sub"
                            :key="index"
                          >
                            {{ item_control3.control_nuevo_sub }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <label class="color_letra"
                          >Asignación a las Medidas de Intervención:</label
                        ><br />
                        <select
                          class="form-control boton_texto"
                          v-model="c_medida_intervencion"
                        >
                          <option value="" selected disabled>
                            Seleccionar...
                          </option>
                          <option value="Eliminación">Eliminación</option>
                          <option value="Sustitución">Sustitución</option>
                          <option value="Controles de Ingeniería">
                            Controles de Ingeniería
                          </option>
                          <option
                            value="Controles Administrativos, Señalización, Advertencia"
                          >
                            Controles Administrativos, Señalización, Advertencia
                          </option>
                          <option
                            value="Equipos/Elementos de Protección Personal"
                          >
                            Equipos/Elementos de Protección Personal
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-12">
                <center>
                  <button
                    type="button"
                    class="btn boton_guardar1 mr-3"
                    style="width: 200px !important"
                    @click="id_peligro"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    class="btn boton_cancelar"
                    @click="vaciar_variables"
                  >
                    Cancelar
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NO TIENE PERMISO PARA VER EL MÓDULO -->
  <div class="alert alert-warning" role="alert" v-else>
    No tiene permiso para ver el Módulo
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "../../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "ControlExistente",
  components: {
    AdminMenu,
  },
  data() {
    return {
      // ARRAYS
      mostrar_peligros_control: [],
      mostrar_subcla_control: [],
      array_peligro: [],
      array_subcla: [],

      // VARIABLES PARA REGISTRO DE CONTROLES EXISTENTES
      session_email: "",
      control_medida: "",
      control_existente: "",
      medida_intervencion: "",
      id_agregar_peligro: "",
      id_agregar_subcla: "",

      // VARIABLES PARA CONSULTAR
      c_key: "",
      c_control_media: "",
      c_peligro: "",
      c_subcla: "",
      c_control_existente: "",
      c_medida_intervencion: "",
      c_registrado: "",
      c_fecha: "",
      c_hora: "",

      // VARIABLES PARA LA TABLA CONTROL EXISTENTES
      array_control: [],
      columns: [
        "control_medida",
        "peligro_control",
        "subcla_control",
        "control_existente",
        "medida_intervencion",
        "opciones",
      ],
      options: {
        headings: {
          control_medida:
            "Descripción del Control Existente y/o Medida de Intervención",
          peligro_control: "Peligro",
          subcla_control: "Subclasificación",
          control_existente: "Asignación a Controles Existentes",
          medida_intervencion: "Asignación a las Medidas de Intervención",
          opciones: "Opciones",
        },
        // responseAdapter({data}) {
        //     return {
        //       data,
        //       count: data.length
        //     }
        // },
        sortable: [
          "control_medida",
          "peligro_control",
          "subcla_control",
          "control_existente",
          "medida_intervencion",
        ],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
      },
    };
  },
  created() {
    if (
      this.$store.state.global_privilegio_admin_registro_control_medida.ver ==
      true
    ) {
      this.tabla_peligro_control();
    }
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;

    var docRef = db
      .collection("nuevo_peligro")
      .orderBy("p_nuevo_peligro", "asc");
    docRef.onSnapshot((querySnapshot) => {
      // LIMPIAR ARRAY ANTES DE CONSULTAR
      this.mostrar_peligros_control = [];
      querySnapshot.forEach((doc) => {
        this.mostrar_peligros_control.push({
          key_peligro_control: doc.id,
          control_nuevo_peligros: doc.data().p_nuevo_peligro,
        });
      });
    });
  },
  methods: {
    // FUNCIÓN PARA MOSTRAR TABLA PROCESO
    tabla_peligro_control() {
      NProgress.start();
      db.collection("nuevo_peligro")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.tabla_subcla_control(
              `${doc.id}`,
              `${doc.data().p_nuevo_peligro}`
            );
          });
        });
    },

    tabla_subcla_control(id_peligro, peligro) {
      db.collection("nuevo_subclasificacion")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.tabla_control(
              id_peligro,
              peligro,
              `${doc.id}`,
              `${doc.data().p_nuevo_subclasificacion}`
            );
          });
        });
    },

    tabla_control(id_peligro, peligro, id_subcla, subcla) {
      if (this.array_control.length > 0) {
      } else {
        (this.array_control = []),
          db
            .collection("nuevo_control_medida")
            .where("cm_id_peligro", "==", id_peligro)
            .where("cm_id_subcla", "==", id_subcla)
            .orderBy("cm_hora_registro", "desc")
            .onSnapshot((snapshot) => {
              let changes = snapshot.docChanges();
              changes.forEach((change) => {
                if (change.type === "added") {
                  this.array_control.unshift({
                    id: `${change.doc.id}`,
                    id_peligro: `${change.doc.data().cm_id_peligro}`,
                    id_subcla: `${change.doc.data().cm_id_subcla}`,
                    control_medida: `${change.doc.data().cm_control_medida}`,
                    peligro_control: peligro,
                    subcla_control: subcla,
                    control_existente: `${
                      change.doc.data().cm_control_existente
                    }`,
                    medida_intervencion: `${
                      change.doc.data().cm_medidas_intervencion
                    }`,
                  });
                } else if (change.type === "modified") {
                  for (
                    let index = 0;
                    index < this.array_control.length;
                    index++
                  ) {
                    if (change.doc.id == this.array_control[index].id) {
                      this.array_control.splice(index, 1);
                    }
                  }
                  this.array_control.unshift({
                    id: `${change.doc.id}`,
                    id_peligro: `${change.doc.data().cm_id_peligro}`,
                    id_subcla: `${change.doc.data().cm_id_subcla}`,
                    control_medida: `${change.doc.data().cm_control_medida}`,
                    peligro_control: peligro,
                    subcla_control: subcla,
                    control_existente: `${
                      change.doc.data().cm_control_existente
                    }`,
                    medida_intervencion: `${
                      change.doc.data().cm_medidas_intervencion
                    }`,
                  });
                } else if (change.type === "removed") {
                  for (
                    let index = 0;
                    index < this.array_control.length;
                    index++
                  ) {
                    if (change.doc.id == this.array_control[index].id) {
                      this.array_control.splice(index, 1);
                    }
                  }
                } else {
                }
                // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
                let set = new Set(this.array_control.map(JSON.stringify));
                this.array_control = Array.from(set).map(JSON.parse);
                NProgress.done();
                NProgress.remove();
              });
            });
      }
      NProgress.done();
      NProgress.remove();
    },

    // CONSULTAR LAS SUBCLASIFICACIONES
    consulta_subcla_control() {
      NProgress.start();
      db.collection("nuevo_subclasificacion")
        .where("p_id_peligro", "==", this.id_agregar_peligro)
        .orderBy("p_nuevo_subclasificacion", "asc")
        .get()
        .then((querySnapshot) => {
          this.mostrar_subcla_control = [];
          querySnapshot.forEach((doc) => {
            this.mostrar_subcla_control.push({
              key_sublca: `${doc.id}`,
              control_nuevo_sub: `${doc.data().p_nuevo_subclasificacion}`,
            });
          });
        });
      NProgress.done();
      NProgress.remove();
    },

    consulta_subcla_control1(c_key_peligro) {
      $("#editarcontrol").modal("show");
      db.collection("nuevo_subclasificacion")
        .where("p_id_peligro", "==", c_key_peligro)
        .orderBy("p_nuevo_subclasificacion", "asc")
        .get()
        .then((querySnapshot) => {
          this.mostrar_subcla_control = [];
          querySnapshot.forEach((doc) => {
            this.mostrar_subcla_control.push({
              key_sublca: `${doc.id}`,
              control_nuevo_sub: `${doc.data().p_nuevo_subclasificacion}`,
            });
          });
        });
      NProgress.done();
      NProgress.remove();
    },

    consulta_subcla_control2() {
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.c_peligro)
        .get()
        .then((querySnapshot) => {
          this.array_peligro = [];
          querySnapshot.forEach((doc) => {
            this.array_peligro.push({
              key_peli: `${doc.id}`,
              control_nuevo_peli: `${doc.data().p_nuevo_peligro}`,
            });
            this.consulta_subcla_control1(`${doc.id}`);
          });
        })
        .catch((error) => {});
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS - DESCRIPCIÓN
    agregar_control_medida() {
      if (this.id_agregar_peligro == "" || this.id_agregar_subcla == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        let newClienteRef = db.collection("nuevo_control_medida").doc();
        let id = newClienteRef.id;
        db.collection("nuevo_control_medida")
          .doc(id)
          .set({
            cm_control_medida: this.control_medida,
            cm_id_peligro: this.id_agregar_peligro,
            cm_id_subcla: this.id_agregar_subcla,
            cm_control_existente: this.control_existente,
            cm_medidas_intervencion: this.medida_intervencion,
            cm_fecha_registro: this.fecha,
            cm_hora_registro: this.hora_actual,
            cm_registrado_por: this.$store.state.email,
          })
          .then(() => {});
        NProgress.done();
        NProgress.remove();

        // FIN ALERTA GUARDANDO
        this.control_medida = "";
        this.id_agregar_peligro = "";
        this.id_agregar_subcla = "";
        this.cm_control_existente = "";
        this.cm_medidas_intervencion = "";
      }
      $("#agregarcontrol").modal("hide");
    },

    // FUNCIÓN PARA MOSTRAR DATOS CLIENTE
    consultar_control_medidas(id, id_peligro, id_subcla) {
      NProgress.start();
      let query01 = db.collection("nuevo_peligro").doc(id_peligro);
      let query02 = db.collection("nuevo_subclasificacion").doc(id_subcla);
      let query03 = db.collection("nuevo_control_medida").doc(id);
      (async () => {
        await query01.get().then((doc) => {
          if (doc.exists) {
            this.c_key_peligro = doc.id;
            this.c_peligro = doc.data().p_nuevo_peligro;
          }
        });

        await query03.get().then((doc) => {
          if (doc.exists) {
            this.c_key = doc.id;
            this.c_control_media = doc.data().cm_control_medida;
            this.c_control_existente = doc.data().cm_control_existente;
            this.c_medida_intervencion = doc.data().cm_medidas_intervencion;
            this.c_registrado = doc.data().cm_registrado_por;
          }
        });
        await query02.get().then((doc) => {
          if (doc.exists) {
            this.c_subcla = doc.data().p_nuevo_subclasificacion;
          }
        });
        this.consulta_subcla_control1(this.c_key_peligro);
      })();
    },

    // VACIAR VARIABLES
    vaciar_variables() {
      $("#editarcontrol").modal("hide");
      this.c_key = "";
      this.c_control_media = "";
      this.c_peligro = "";
      this.c_subcla = "";
      this.c_fuente = "";
      this.c_medio = "";
      this.c_individuo = "";
      this.c_eliminacion = "";
      this.c_sustitucion = "";
      this.c_controles = "";
      this.c_controles_admin = "";
      this.c_equipos = "";
      this.c_registrado = "";
    },

    id_peligro() {
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.c_peligro)
        .onSnapshot((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.id_subcla(`${doc.id}`);
          });
        });
      this.c_peligro = "";
    },

    id_subcla(id_peligro) {
      db.collection("nuevo_subclasificacion")
        .where("p_nuevo_subclasificacion", "==", this.c_subcla)
        .onSnapshot((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.editar_control_medida(id_peligro, `${doc.id}`);
          });
        });
      this.c_subcla = "";
    },

    // FUNCIÓN PARA EDITAR CONTROL EXISTENTE
    editar_control_medida(id_peligro, id_subcla) {
      if (id_peligro == "" || id_subcla == "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        db.collection("nuevo_control_medida")
          .doc(this.c_key)
          .set({
            cm_control_medida: this.c_control_media,
            cm_id_peligro: id_peligro,
            cm_id_subcla: id_subcla,
            cm_control_existente: this.c_control_existente,
            cm_medidas_intervencion: this.c_medida_intervencion,
            cm_fecha_registro: this.c_fecha,
            cm_hora_registro: this.c_hora,
            cm_registrado_por: this.$store.state.email,
          })
          .then(() => {});

        id_peligro = "";
        id_subcla = "";
        this.c_control_media = "";
        this.c_control_existente = "";
        this.c_medida_intervencion = "";
        NProgress.done();
        NProgress.remove();
        $("#editarcontrol").modal("hide");
      }
    },

    // FUNCIÓN PARA ELIMINAR CONTROL EXISTENTE
    eliminar_control(id_control) {
      Swal.fire({
        title: "¿Seguro que desea eliminar este control?",
        text: "¡Una vez eliminado, no podrás volver a ver el registro!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          db.collection("nuevo_control_medida")
            .doc(id_control)
            .delete()
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Datos eliminados satisfactoriamente.",
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            });
        }
      });
    },
  },
};
</script>